import type { App } from 'vue';

import { globalState } from 'boot/simpleObservableStore';

import { EventBus } from 'src/util/eventBus/EventBus';

export function bootEventBus({ app }: { app: App<Element> }): void {
	const eventBus = new EventBus();

	app.config.globalProperties.$eventBus = eventBus;

	globalState.eventBus = eventBus;

	app.provide('eventBus', eventBus);
}
